import React from 'react';
import { useAuth } from '../hooks/useAuth';
import './UserMenu.css';

const UserMenu = ({ isOpen, onClose }) => {
  const { user, logout, userDisplayName, userEmail, isEmailVerified } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  if (!isOpen || !user) return null;

  return (
    <div className="user-menu-overlay" onClick={onClose}>
      <div className="user-menu" onClick={(e) => e.stopPropagation()}>
        <div className="user-menu-header">
          <div className="user-avatar">
            {userDisplayName?.charAt(0)?.toUpperCase() || '👤'}
          </div>
          <div className="user-info">
            <div className="user-name">{userDisplayName}</div>
            <div className="user-email">{userEmail}</div>
            {!isEmailVerified && (
              <div className="verification-status">
                ⚠️ Email no verificado
              </div>
            )}
          </div>
        </div>
        
        <div className="user-menu-body">
          <button className="user-menu-item" onClick={() => {}}>
            <span className="menu-icon">👤</span>
            Mi Perfil
          </button>
          <button className="user-menu-item" onClick={() => {}}>
            <span className="menu-icon">⚙️</span>
            Configuración
          </button>
          <hr className="menu-separator" />
          <button className="user-menu-item logout" onClick={handleLogout}>
            <span className="menu-icon">🚪</span>
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserMenu;
